import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

type ContainerProps = {
  children: ReactNode;
  className?: string;
};

/** Conteneur de page : 1280 px max, marges 48 px, 22 px sous 720 px (maquette, `.wrap`). */
export function Container({ children, className }: ContainerProps) {
  return (
    <div className={cn('mx-auto w-full max-w-page px-5.5 tab:px-12', className)}>
      {children}
    </div>
  );
}
